import { useEffect, useState } from "react";
import { adapter } from "@/services/db";
import { COLLECTION_GROUPS } from "@/lib/collections";
import { cn } from "@/lib/utils";

export function CollectionList({ active, onPick }) {
  const [counts, setCounts] = useState({});
  useEffect(() => {
    COLLECTION_GROUPS.flatMap((g) => g.items).forEach((c) => {
      adapter.count(c).then((n) => setCounts((m) => ({ ...m, [c]: n }))).catch((e) => setCounts((m) => ({ ...m, [c]: e.code === "permission-denied" ? "locked" : "err" })));
    });
  }, []);
  return (
    <nav className="space-y-4" data-testid="collection-list">
      {COLLECTION_GROUPS.map((g) => (
        <div key={g.group}>
          <p className="text-[10px] font-mono uppercase tracking-wider text-muted-foreground px-2 mb-1">{g.group}</p>
          {g.items.map((c) => {
            const n = counts[c];
            return (
              <button key={c} onClick={() => onPick(c)} data-testid={`coll-${c}`}
                className={cn("w-full flex items-center justify-between rounded-md px-2 py-1.5 text-xs font-mono transition-colors",
                  active === c ? "bg-primary text-primary-foreground" : "hover:bg-accent text-foreground", n === 0 && active !== c && "opacity-50")}>
                <span className="truncate">{c}</span>
                <span className={cn("ml-2 text-[10px]", n === "locked" && "text-red-500")} data-testid={`coll-count-${c}`}>{n ?? "…"}</span>
              </button>
            );
          })}
        </div>
      ))}
    </nav>
  );
}
